import { TGetGiftCardsRes } from "./giftCards"
import axiosInstance from '../lib/axios-instance';;

export const getDigitalPayments = async (): Promise<TGetGiftCardsRes> => {
  try {
    const res = await axiosInstance.get('/digital-payments');

    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error('Failed to get gift cards');
  }
};
